module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.41919","quantity":0.00419},{"color":"#9dc4b5","label":" 0.41919- 2.39226","quantity":0.02392},{"color":"#e6efc3","label":" 2.39226- 3.2235","quantity":0.03224},{"color":"#ffe89e","label":" 3.2235- 4.50088","quantity":0.04501},{"color":"#f5af7f","label":" 4.50088- 6.72152","quantity":0.06722},{"color":"#ed6d32","label":" 6.72152- 23.85079","quantity":0.23851}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_100.json
// module id = dNyg
// module chunks = 171